import { render, staticRenderFns } from "./DashboardCardInfo.vue?vue&type=template&id=97b1adbe&scoped=true&"
import script from "./DashboardCardInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardInfo.vue?vue&type=style&index=0&id=97b1adbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b1adbe",
  null
  
)

export default component.exports